import _get from 'lodash/get';
import { createSelector } from 'reselect';

import { createReducer } from 'utils/reducer';

import * as hellosignActions from './actions';
import * as helpers from './reducerHelpers';

/**
 * Initialize the 'hellosign' state.
 *
 * @type {Object}
 */
export const INITIAL_STATE = {};

/**
 * Build the map of 'hellosign' redux henadlers.
 *
 * @type {Object}
 */
const hellosign = {
    [hellosignActions.fetchPdfAndSigningUrl.SUCCESS]: helpers.fetchPdfAndSigningUrlSuccess,
    [hellosignActions.fetchPdfUrl.SUCCESS]          : helpers.fetchPdfUrlSuccess,
    [hellosignActions.fetchSigningUrl.SUCCESS]      : helpers.fetchSigningUrlSuccess,
    [hellosignActions.loadSigningIframe.SUCCESS]    : helpers.loadSigningIframeSuccess,
    [hellosignActions.validateToken.SUCCESS]        : helpers.validateTokenSuccess
};

// Create and export the 'hellosign' reducer.
// NOTE: The default export will be the reducer.
export default createReducer(INITIAL_STATE, hellosign);

// Create and export named 'hellosign' selectors.
// NOTE: The rest of the 'named' exports will be the selectors, for this module.

/**
 * Get all the info about the HelloSign.
 *
 * @method getHelloSignInfo
 * @param  {Object}         state The current state
 * @return {Object}               HelloSign info
 */
export const getHelloSignInfo = state => _get(state, 'hellosign.info', {});

/**
 * Get the embedded signing url
 *
 * @type {Function}
 */
export const getEmbeddedUrl = createSelector(
    [getHelloSignInfo],
    info => _get(info, 'embeddedSigningURL')
);

/**
 * Get the document name from the handbook info.
 *
 * @type {Function}
 */
export const getDocumentName = createSelector(
    [getHelloSignInfo],
    info => _get(info, 'documentName')
);
